import * as z from 'zod/v4';

interface BookmarkType {
  client_id: string;
  name: string;
  kind: string;
  sub_kind?: string | null;
  pinned?: boolean;
  order: number;
  path: string;
  color?: string | null;
  icon?: string | null;
  query_params?: Record<string, string>;
}

interface FolderType {
  client_id: string;
  name: string;
  kind: 'bookmark' | 'workflow';
  order: number;
  color?: string | null;
  icon?: string | null;
  pinned?: boolean;
  sub_kind?: string | null;
  child_folders?: FolderType[];
  child_bookmarks?: BookmarkType[];
  shared_by?: string | null;
}

export const BookmarkSchema = z.object({
  client_id: z.string(),
  name: z.string(),
  kind: z.string(),
  sub_kind: z.string().optional().nullable(),
  pinned: z.boolean().optional(),
  order: z.number(),
  path: z.string(),
  color: z.string().optional().nullable(),
  icon: z.string().optional().nullable(),
  query_params: z.record(z.string(), z.string()).optional(),
});

const baseFolderSchema = z.object({
  client_id: z.string(),
  name: z.string(),
  kind: z.enum(['bookmark', 'workflow']),
  order: z.number(),
  color: z.string().optional().nullable(),
  icon: z.string().optional().nullable(),
  pinned: z.boolean().optional(),
  sub_kind: z.string().optional().nullable(),
  child_bookmarks: z.array(BookmarkSchema).optional(),
  shared_by: z.string().optional().nullable(),
});

export const FolderSchema: z.ZodType<FolderType> = baseFolderSchema.extend({
  child_folders: z.lazy(() => z.array(FolderSchema)).optional(),
});

export const WorkEngagementBookmarksSchema = z.object({
  customer_id: z.string().readonly(),
  work_engagement_id: z.string(),
  bookmarks: z.array(BookmarkSchema),
  folders: z.array(FolderSchema),
});

export const WorkEngagementBookmarksArraySchema = z.array(
  WorkEngagementBookmarksSchema
);

export const UserBookmarksSchema = z.object({
  bookmarks: z.array(BookmarkSchema),
  customer_id: z.string().readonly(),
  folders: z.array(FolderSchema),
  folders_shared_with_me: z.array(FolderSchema),
  subscribed_work_engagements: z.array(z.unknown()),
  user_id: z.string().readonly(),
});
